import { withAppBase } from '@/utils/appBase'

const skillAsset = (name: string) => withAppBase(`/skills/${name}`)

export const aiSkillsLandingAssets = {
  pixelBlast1: skillAsset('pixelBlast1.png'),
  pixelBlast2: skillAsset('pixelBlast2.png'),
  rbGradient: skillAsset('rbGradient.jpeg'),
  logo2025: skillAsset('logo2025.png'),
  logo2025Dark: skillAsset('logo2025Dark.png'),
  iconSearch: skillAsset('iconSearch.svg'),
  iconSearchClear: skillAsset('iconSearchClear.svg'),
  iconGlobe: skillAsset('iconGlobe.svg'),
  iconChevron: skillAsset('iconChevron.svg'),
  iconMoon: skillAsset('iconMoon.svg'),
  iconMoonDark: skillAsset('iconMoonDark.svg'),
  iconCopyDoc: skillAsset('iconCopyDoc.svg'),
  iconChevronLink: skillAsset('iconChevronLink.svg'),
  iconCheckBadge: skillAsset('iconCheckBadge.svg'),
  aiHermesBg: skillAsset('aiHermesBg.png'),
  aiOpenClaw: skillAsset('aiOpenClaw.png'),
  aiClaude: skillAsset('aiClaude.png'),
  aiCursor: skillAsset('aiCursor.png'),
  /** Codex 小图标（设计稿矢量切片） */
  aiCodexMark: skillAsset('aiCodexMark.svg'),
  iconArrowOut: skillAsset('iconArrowOut.svg'),
  iconCapProgress: skillAsset('iconCapProgress.svg'),
  iconCapResult: skillAsset('iconCapResult.svg'),
  iconCapSource: skillAsset('iconCapSource.svg'),
  iconOfficialDots: skillAsset('iconOfficialDots.svg'),
  iconQuoteCheck: skillAsset('iconQuoteCheck.svg'),
  quoteAvatarChen: skillAsset('quoteAvatarChen.png'),
  quoteAvatarLi: skillAsset('quoteAvatarLi.png'),
  quoteAvatarWang: skillAsset('quoteAvatarWang.png'),
  phoneDevice: skillAsset('phoneDevice.png'),
  phoneScreen: skillAsset('phoneScreen.png'),
  phoneNotch: skillAsset('phoneNotch.png'),
  phoneShadow: skillAsset('phoneShadow.svg'),
  appMarketLineHsi: skillAsset('appMarketLineHsi.svg'),
  appMarketLineHscei: skillAsset('appMarketLineHscei.svg'),
  appMarketLineTech: skillAsset('appMarketLineTech.svg'),
  appChipHk: skillAsset('appChipHk.svg'),
  appChipOption: skillAsset('appChipOption.svg'),
  appChipUs: skillAsset('appChipUs.svg'),
  appChipFund: skillAsset('appChipFund.svg'),
  appUnderline: skillAsset('appUnderline.svg'),
  downloadQRIos: skillAsset('downloadQR-ios.png'),
  downloadQRAndroid: skillAsset('downloadQR-android.png'),
  downloadPopArrow: skillAsset('downloadPopArrow.svg'),
  installLockArrow: skillAsset('installLockArrow.svg'),
  contactUs: skillAsset('contactUs.png'),
  tabIcon1: skillAsset('tab-icon-1.svg'),
  tabIcon2: skillAsset('tab-icon-2.svg'),
  tabIcon3: skillAsset('tab-icon-3.svg'),
  tabIcon4: skillAsset('tab-icon-4.svg'),
  tabIcon5: skillAsset('tab-icon-5.svg'),
  sendIcon: skillAsset('send-icon.svg'),
  rightQuotesIcon: skillAsset('right-quotes-icon.svg'),
  leftQuotesIcon: skillAsset('left-quotes-icon.svg'),
  resetIcon: skillAsset('reset-icon.svg'),
  downloadIcon: skillAsset('download-icon.svg'),
} as const
